import {
  fetchDELETERequest,
  fetchGETRequest,
  fetchPOSTRequest,
  fetchPUTRequest,
} from "./services";

const API_V2_TARIFFS = "v2/Tariffs";

export interface TimeOfUseV2 {
  hour: number;
  minute: number;
  second?: number;
  millisecond?: number;
  microsecond?: number;
  nanosecond?: number;
  ticks?: number;
}

export interface TariffSlabV2 {
  id: string;
  tariffId: string;
  slabName: string;
  minUnits: number;
  maxUnits: number;
  ratePerUnit: number;
  fixedCharge: number;
  timeOfUseStart: TimeOfUseV2 | string;
  timeOfUseEnd: TimeOfUseV2 | string;
  slabType: string;
  isActive: boolean;
  createdAt: string;
}

export interface TariffV2 {
  id: string;
  tariffCode: string;
  name: string;
  description: string;
  effectiveFrom: string;
  effectiveTo: string;
  isActive: boolean;
  version: number;
  createdAt: string;
  updatedAt: string;
  slabs: TariffSlabV2[];
}

export interface CreateTariffV2Request {
  tariffCode: string;
  name: string;
  description: string;
  effectiveFrom: string;
  effectiveTo: string;
}

export interface UpdateTariffV2Request {
  name: string;
  description: string;
  effectiveTo: string;
  isActive: boolean;
}

export interface CreateTariffSlabV2Request {
  slabName: string;
  minUnits: number;
  maxUnits: number;
  ratePerUnit: number;
  fixedCharge: number;
  slabType: string;
  timeOfUseStart: {
    hour: number;
    minute: number;
  };
  timeOfUseEnd: {
    hour: number;
    minute: number;
  };
}

export const getTariffsV2 = async () => {
  return await fetchGETRequest<{
    success: boolean;
    data: TariffV2[];
    errors: any;
  }>(API_V2_TARIFFS);
};

export const createTariffV2 = async (body: CreateTariffV2Request) => {
  return await fetchPOSTRequest<{
    success: boolean;
    data: TariffV2;
    message: string;
    errors: any;
  }>(API_V2_TARIFFS, body);
};

export const getTariffDetailsV2 = async (id: string) => {
  return await fetchGETRequest<{
    success: boolean;
    data: TariffV2;
    errors: any;
  }>(`${API_V2_TARIFFS}/${id}`);
};

export const updateTariffV2 = async (
  id: string,
  body: UpdateTariffV2Request,
) => {
  return await fetchPUTRequest<{
    success: boolean;
    data: TariffV2;
    message: string;
    errors: any;
  }>(`${API_V2_TARIFFS}/${id}`, body);
};

export const deleteTariffV2 = async (id: string) => {
  return await fetchDELETERequest<{
    success: boolean;
    message: string;
    errors: any;
  }>(`${API_V2_TARIFFS}/${id}`);
};

export const createTariffSlabV2 = async (
  tariffId: string,
  body: CreateTariffSlabV2Request,
) => {
  return await fetchPOSTRequest<{
    success: boolean;
    data: TariffSlabV2;
    message: string;
    errors: any;
  }>(`${API_V2_TARIFFS}/${tariffId}/slabs`, body);
};

export const deleteTariffSlabV2 = async (tariffId: string, slabId: string) => {
  return await fetchDELETERequest<{
    success: boolean;
    message: string;
    data: { slabId: string };
    errors: any;
  }>(`${API_V2_TARIFFS}/${tariffId}/slabs/${slabId}`);
};

export const updateTariffSlabV2 = async (
  tariffId: string,
  slabId: string,
  body: CreateTariffSlabV2Request,
) => {
  return await fetchPUTRequest<{
    success: boolean;
    data: TariffSlabV2;
    message: string;
    errors: any;
  }>(`${API_V2_TARIFFS}/${tariffId}/slabs/${slabId}`, body);
};
